<template>
    <div>
        <div class="box_top">
            <div class="el-icon-s-home">当前位置：</div>
            <el-breadcrumb separator=">>">
                <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>社会捐赠</el-breadcrumb-item>
                <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="box_imgae">
            <div class="box_imgae_left">
                <div class="box_image_left_pic">
                    <img src="../assets/image/bit9.png" alt="">
                </div>
                <div class="box_image_left_detail">
                    <div style="marginBottom:10px">累计捐赠资金</div>
                    <div>资金总额<span>{{fundnum}}</span>元</div>
                </div>
            </div>
            <div class="box_imgae_left">
                <div class="box_image_left_pic">
                    <img src="../assets/image/bit8.png" alt="">
                </div>
                <div class="box_image_left_detail">
                    <div style="marginBottom:10px">累计捐赠物品</div>
                    <div>物品总价值<span>{{goodsnum}}</span>元</div>
                </div>
            </div>
            <div @click="picbtn(url)">
                <img :src="donate" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type:String
        },
        fundnum:{
            type:Number
        },
        goodsnum:{
            type:Number
        }
    },
    data(){
        return{
            // 捐赠图
            donate:'',
            url:''
        }
    },
    created(){
        // this.donate=window.sessionStorage.getItem('donate')
        this.getDonantPic()
    },
    methods:{
        async getDonantPic(){
            const {data:res}=await this.$http.get('/index/siteInfo')
            if(res.code==200){
                res.data.pics.forEach(item => {
                    if(item.name=="捐赠页小图"){
                        this.donate=item.imgsrc
                        this.url=item.url
                    }
                });
            }
        },
        // 点击图片跳转
        picbtn(url){
            window.location.href=url
        }
    }
}
</script>

<style lang="less" scoped>
.box_top{
    height: 46px;
    border-bottom: 1px solid #edebea;
    margin-top: 15px;
    line-height: 46px;
    display: flex;
    align-items: center;
    div{
        font-size: 14px;
        color: #666;
    }
    .el-breadcrumb{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }
}
.box_imgae{
    height: 110px;
    margin: 15px 0;
    display: flex;
    justify-content: space-between;
    >div{
        width: 380px;
        height: 110px;
    }
    .box_imgae_left{
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #edebea;
        .box_image_left_pic{
            width: 80px;
            height: 80px;
            margin-right: 15px;
        }
        .box_image_left_detail{
            width: 270px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 18px;
            >div>span{
                color:#da5d61;
                font-size: 24px;
                font-weight: bold;
            }
        }  
    }
}
img{
    width: 100%;
    height: 100%;
}
</style>